module.exports = __webpack_public_path__ + "static/media/Tiffany.5cad8cda.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/Media/Tiffany.JPG
// module id = 84
// module chunks = 0